<template>
  <span>
    <highcharts :options="chartOptions" :deepCopyOnUpdate="false" />
  </span>
</template>

<script>
  import columnChartMixin from "./columnChartMixin";

  export default {
    name: "ChartPrpPorCompetencia",
    mixins: [columnChartMixin],
    props: {
      dadosPorCompetencia: {
        type: Object,
        required: true,
      },
      categories: {
        type: Array,
        required: true
      }
    },
    data: () => ({
      chartOptions: {},
    }),
    methods: {
      setChartOptions() {
        this.chartOptions = this.getColumnChartOptions(
          this.getPrpPorCompetenciaRemainingChartOptions()
        );
      },
      getPrpPorCompetenciaRemainingChartOptions() {
        return {
          xAxis: {
            type: "category",
            title: {
              text: "Competência",
            },
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: "{point.y:.2f}%",
              },
            },
          },
          series: [
            {
              name: "PRP",
              data: this.categories
                .map((category) => {
                  return category in this.dadosPorCompetencia
                    ? {
                        name: category,
                        y: Number(this.dadosPorCompetencia[category].prp),
                      }
                    : {
                        name: category,
                        y: 0,
                      };
                })
                .filter((val) => val !== null && val.y !== null && val.y > 0),
            },
          ],
        };
      },
    },
    watch: {
      dadosPorCompetencia() {
        this.setChartOptions();
      },
    },
  };
</script>

<style></style>
